import { memo } from "react";
import Button from "components/Elements/Button/Button";

import styles from "../thanksActionModals.module.scss";

interface ModalNavigationButtonsI {
  handleBack: (modalId: string) => void;
  handleNext: () => void;
  nextButtonText: string;
  backButtonText: string;
  isThirdStep: boolean;
}

const ModalNavigationButtons = memo(
  ({
    handleBack,
    handleNext,
    nextButtonText,
    backButtonText,
    isThirdStep,
  }: ModalNavigationButtonsI) => {
    return (
      <>
        {!isThirdStep && (
          <Button
            onClick={handleBack}
            className={`${styles.btn} ${styles.backBtn}`}
          >
            {backButtonText}
          </Button>
        )}
        {!isThirdStep && (
          <Button
            onClick={handleNext}
            className={`${styles.btn} ${styles.nextBtn}`}
          >
            {nextButtonText}
          </Button>
        )}
      </>
    );
  }
);

export default ModalNavigationButtons;
